import { DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR } from '@/constants/ui';
import React from 'react';

const MYOPhysicalDomain = ({
  color,
  size = 50,
  background = DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR,
}: {
  color: string;
  size?: number;
  background?: string;
}) => (
  <svg viewBox="0 0 100 100" width={size} height={size} fill={'none'}>
    <rect width="100" height="100" rx="18" fill={background} />
    <path
      d="M41.118 56.8294C40.8449 56.525 40.7786 56.0875 40.9478 55.7154C43.1627 50.8465 40.7603 48.1217 40.9996 37.1209C41.011 36.5986 41.4178 36.1005 42.0698 36.1129C42.6319 36.1236 43.0723 36.6014 43.06 37.1634C43.0493 37.6524 43.0446 38.1434 43.0452 38.6355C43.046 39.2059 43.5116 39.6715 44.0819 39.6637C45.7579 39.6408 49.018 39.0889 50.2797 35.3039L50.9073 33.4215C52.0685 29.9377 50.0846 26.1765 46.5165 25.1944L40.0994 23.4282C37.5429 22.7246 34.7746 23.6886 33.2098 25.827C25.7052 36.0816 20.7227 47.8748 18.6068 60.3667C18.0253 63.7993 19.6567 67.2627 22.6666 68.9848C39.5666 78.6543 59.6056 79.5912 77.7622 71.1317C79.3115 70.41 80.3127 69.4937 80.6746 67.0184C81.0366 64.5431 81.5802 63.9727 81.5802 57.9187C81.5802 51.8647 80.727 49.5102 80.3124 48.3027C79.8978 47.0953 79.5895 45.8769 78.378 45.0559C71.8642 40.6412 63.5696 41.1699 58.0136 47.0317C57.5184 47.5541 57.7061 48.4106 58.3703 48.6883C60.8803 49.7378 63.2533 51.2626 65.2339 53.0635C65.6644 53.4551 65.6946 54.1333 65.2671 54.5597C64.879 54.9466 64.2567 54.9611 63.8499 54.5938C58.6602 49.9072 51.6441 47.775 44.6642 50.005C44.2361 50.1418 43.9493 50.547 43.9563 50.9964C43.9856 52.8656 43.6735 54.6756 42.8205 56.5715C42.5162 57.2473 41.6127 57.3809 41.118 56.8294Z"
      fill={color}
    />
  </svg>
);

export default MYOPhysicalDomain;
